<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Mutual Funds Data '}} - {{selMutualTab}} - <b class="ml-2"> {{ last_updated_date }} </b> </strong>
        </div>
        <div class="col-md-5"> 
          <div class="mr5 pull-right">
            <router-link class="btn btn-sm btn-small btn-warning" :to="'/mutual-funds/qualitative-statements'">
              <i :title="'Qualitative Statements'" class="fa fa-edit cwhite"></i> Qualitative Statement
            </router-link>
            <router-link class="btn btn-sm btn-small btn-primary" :to="'/mutual-funds/edit-debt/ratings'">
              <i :title="'Edit Rating'" class="fa fa-edit cwhite"></i> Debt Ratings
            </router-link>
            <router-link class="btn btn-sm btn-small btn-primary" :to="'/mutual-funds/edit-mf-form/multiplier'">
              <i :title="'Edit Debt Multiplier'" class="fa fa-edit cwhite"></i> Debt Multiplier
            </router-link>
            <router-link class="btn btn-sm btn-small btn-primary" :to="'/mutual-funds/edit-mf-rating-form/ratings_number_and_text'">
              <i :title="'Edit Ratings'" class="fa fa-edit cwhite"></i> Star Ratings
            </router-link>
          </div>        
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          </div>
        </div>
        <vue-tabs
          v-model="selMutualTab"
          direction="horizontal"
          @tab-change="getTabData"
        >
          <v-tab
            :title="rd.value"
            v-for="(rd, index) in rawDataList"
            v-bind:key="index"
          >
          <div class="mb10"></div>
            <div class="row mb5">
              <div class="col-md-11">
                <div class="row">
                  <div class="col-md-3" v-if="checkInArray(dateFilterTabs, rawDataType)">
                    <div class="form-group">
                      <datepicker
                        :input-class="'form-control'"
                        :format="'dd-MM-yyyy'"
                        v-model="durDate"
                        @selected="getDateData($event)"
                        :disabledDates="disabledDates"
                        :placeholder="'Select Date'"
                      ></datepicker>
                    </div>
                  </div>
                  <div class="col-md-3" v-if="rawDataType=='fund-houses'">
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="searchText"
                        class="form-control"
                        name="search"
                        placeholder="Search by nameamc/Lname"
                        @keyup="search"
                      >
                    </div>
                  </div>
                  <div class="col-md-6" v-if="rawDataType=='fund-houses'"></div>
                  <div class="col-md-3" v-if="rawDataType == 'fund-wise-monthly-aum'">
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="amc_name"
                        class="form-control"
                        name="scheme_name"
                        placeholder="Search by AMC Name"
                        @keyup="filterSchemes"
                      >
                    </div>
                  </div>
                  <div class="col-md-5" v-if="rawDataType=='schemes' || rawDataType=='scheme-nav-latest' 
                  || rawDataType == 'scheme-ratios' || rawDataType == 'scheme-aum' || rawDataType == 'avg-maturity-data' || rawDataType == 'scheme-asset-allocation'">
                    <div class="form-group">
                      <v-select
                        :options="schemeList"
                        :placeholder="'Select Scheme'"
                        :label="'name'"
                        v-model="selScheme"
                        @input="getScheme"
                        >
                      </v-select>
                    </div>
                  </div>
                  <div class="col-md-5" v-if="rawDataType=='scheme-nav-historical' || rawDataType == 'sector-historical'">
                    <div class="form-group">
                      <v-select
                        :options="scheme_class_codes"
                        :placeholder="'Select Scheme Type'"
                        :label="'name'"
                        v-model="selSchemeClass"
                        @input="getSchemeClassCode"
                        >
                        </v-select>
                    </div>
                  </div>
                  <div class="col-md-3" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="lname"
                        class="form-control"
                        name="lname"
                        placeholder="Search by LName"
                        @keyup.enter="filterSchemes"
                      >
                    </div>
                  </div>
                  <div class="col-md-4" v-if="rawDataType=='schemes'">
                    <div class="form-group">
                      <!-- <input
                        type="text"
                        v-model="fund_manager"
                        class="form-control"
                        name="fund_manager"
                        placeholder="Search by Fund Manager"
                      > -->
                      <v-select
                        :options="fundManagerList"
                        :placeholder="'Select Fund Manager'"
                        :label="'name'"
                        v-model="selFundManager"
                        @input="filterSchemes"
                      ></v-select>
                    </div>
                  </div>
                  <div class="col-md-3" v-if="rawDataType=='schemes' || rawDataType == 'scheme-ratios' || rawDataType == 'scheme-aum'">
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="category"
                        class="form-control"
                        name="category"
                        placeholder="Search by Category"
                        @keyup.enter="filterSchemes"
                      >
                    </div>
                  </div>
                   <div class="col-md-3" v-if="rawDataType == 'sector-historical'">
                    <div class="form-group">
                      <input
                        type="text"
                        v-model="sector_search"
                        class="form-control"
                        name="sector"
                        placeholder="Search by Sector"
                        @keyup.enter="filterSchemes"
                      >
                    </div>
                  </div>
                  <div class="col-md-7" v-if="rawDataType=='scheme-nav-latest' || rawDataType=='scheme-nav-historical'"></div>
                  <!--- SCHEME RETURNS --->
                  <div class="col-md-4" v-if="rawDataType == 'whats-in-out' || rawDataType == 'scheme-returns' || rawDataType == 'scheme-master-info' || rawDataType == 'scheme-return-ranks'">
                    <v-select
                        :options="schemeList"
                        :placeholder="'Select Scheme'"
                        :label="'name'"
                        v-model="selScheme"
                        @input="getScheme"
                        >
                      </v-select>
                  </div>
                  <div class="col-md-3" v-if="rawDataType == 'whats-in-out' || rawDataType == 'scheme-returns' || rawDataType == 'scheme-return-ranks' || rawDataType == 'category-wise-returns' || rawDataType == 'scheme-ratios' || rawDataType == 'avg-maturity-data' || rawDataType == 'scheme-asset-allocation'">
                    <div class="form-group">
                      <v-select
                        :options="scheme_class_codes"
                        :placeholder="'Select Scheme Type'"
                        :label="'name'"
                        v-model="selSchemeClass"
                        @input="getSchemeClassCode"
                        >
                      </v-select>
                    </div>
                  </div>
                  <!--- END SCHEME RETURNS --->
                  <template v-if="rawDataType=='whats-in-out' || rawDataType=='schemes' || rawDataType=='scheme-return-ranks' || rawDataType=='sector-historical' || rawDataType=='scheme-returns' || rawDataType=='scheme-ratios' || rawDataType=='fund-wise-monthly-aum' || rawDataType== 'scheme-aum' || rawDataType == 'avg-maturity-data' || rawDataType == 'scheme-asset-allocation'">
                     <div class="col-md-1" >
                    <div class="form-group">
                      <button class="btn btn-primary" @click="getRawData(1)">Filter</button>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="form-group">
                      <button class="btn btn-default" @click="resetFilter">Reset</button>
                    </div>
                  </div>
                  </template>
                </div>
              </div>
              <div class="col-md-1" v-if="rawDataType != 'dashboard'">
                <download :tableId="'mf'+rawDataType" :fileName="rawDataType"></download>
              </div>
            </div>
            <div class="row mb5">
              <div class="col-md-6">
                <div><router-link class="btn btn-sm btn-secondary" :to="'/mutual-funds/schemes/'" >View Scheme-wise data</router-link></div>
              </div>
              <div class="col-md-6" v-if="rawDataType !== 'scheme-nav-historical'">
                <div class="pull-right">
                  <ul v-if="totalPages != 1" class="pagination">
                    <li :class="{disabled:prevDisabled}" class="page-item">
                      <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                    </li>
                    <li :class="{disabled:prevDisabled}" class="page-item">
                      <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                    </li>
                    <li
                      v-for="page in pages"
                      v-bind:key="page"
                      class="page-item"
                      :class="(current_page == page)? 'active':''"
                    >
                      <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                    </li>
                    <li :class="{disabled:nextDisabled}" class="page-item">
                      <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                    </li>
                    <li :class="{disabled:nextDisabled}" class="page-item">
                      <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-12" v-if="checkInArray(allDownloadTabs, rawDataType)">
                <div class="pull-right"><button class="btn btn-sm" @click="downLoadAll">Download All</button></div>
              </div>
            </div>
            <div class="row mb5" v-if="rawDataType == 'dashboard'">
              <div class="col-md-3">
                <span v-if="rawData.total"><strong>Total Schemes:</strong> {{rawData.total? rawData.total: '-'}}</span>
              </div>
              <div class="col-md-3">
                <span v-if="rawData.fundmanagerwise"><strong>Total Fund Managers:</strong> {{rawData.fundmanagerwise? (rawData.fundmanagerwise.length): '-'}}</span>
              </div>
              <div class="col-md-3">
                <span v-if="rawData.categorieswise"><strong>Total Categories:</strong> {{rawData.categorieswise? (rawData.categorieswise.length): '-'}}</span>
              </div>
            </div>
            <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length && checkNotInArray(uncommonTabs, rawDataType)">
              <table :id="'mf'+rawDataType" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in tableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >
                    <span v-if="rawDataType=='scheme-ratios'">
                      <span v-if="field.isSortable" @click="sortColumn(field, index)">
                        {{field.name}}
                          <span class="sort" :class="(sort==field.title && sortOrder=='ASC')? 'active':''" >
                            <i class="fa fa-caret-down"></i></span>
                          <span class="sort" :class="(sort==field.title && sortOrder=='DESC')? 'active':''">
                            <i class="fa fa-caret-up"></i></span>
                        </span>
                        <span v-else>{{field.name}}</span>
                    </span>
                    <span v-else>{{field.name}}</span>
                    </th>
                    <th v-if="actions.length">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                    <td>
                      <span v-if="rawDataType=='schemes'">
                        <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                        <span v-else>{{ind+1}}</span>
                      </span>
                      <span v-else>{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in tableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                    <span v-if="cl.isLink">
                      <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                      <router-link class="a-btn" :to="'/mutual-funds/schemes/' + tr[cl.title]" target="_blank">{{tr[cl.title]}}</router-link>
                    </span>
                    <span v-else>
                      <span v-if="cl.datatype=='date'">{{(tr[cl.title])? (tr[cl.title].split('T')[0]): '-'}}</span>
                      <span v-else-if="cl.datatype=='numeric'">{{(tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                      <span v-else-if="cl.datatype=='array'">{{(tr[cl.title] && tr[cl.title].length && tr[cl.title][0].sch_name)? (tr[cl.title][0].sch_name): (tr[cl.title].length)? tr[cl.title][0]: '-'}}</span>
                      <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                    </span>
                    </td>
                    <td v-if="actions.length">
                      <div class="action-btn-wrapper" v-for="action in actions"
                          v-bind:key="'action'+action.tooltip">
                          <span v-if="action.isLink">
                        <router-link
                          style="margin:1px 4px"
                          class="a-btn"
                          :class="action.btnClass"                        
                          :to="action.url+tr[action.param]"
                          :target="action.isNewWindow? '_blank': ''"
                          :title="action.tooltip" 
                        > {{action.tooltip}}
                        </router-link>
                          </span>
                          <span v-else><a
                          style="margin:1px 4px"
                          class="a-btn"
                          :class="action.btnClass"                        
                          @click.prevent="action.callback(tr['mf_schcode'])"
                          :title="action.tooltip" 
                        > {{action.tooltip}}
                        </a></span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length && rawDataType == 'whats-in-out'">
              <table :id="'mf'+rawDataType" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in tableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >
                    <span v-if="rawDataType=='scheme-ratios'">
                      <span v-if="field.isSortable" @click="sortColumn(field, index)">
                        {{field.name}}
                          <span class="sort" :class="(sort==field.title && sortOrder=='ASC')? 'active':''" >
                            <i class="fa fa-caret-down"></i></span>
                          <span class="sort" :class="(sort==field.title && sortOrder=='DESC')? 'active':''">
                            <i class="fa fa-caret-up"></i></span>
                        </span>
                        <span v-else>{{field.name}}</span>
                    </span>
                    <span v-else>{{field.name}}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                    <td>
                      <span v-if="rawDataType=='schemes'">
                        <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                        <span v-else>{{ind+1}}</span>
                      </span>
                      <span v-else>{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in tableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                    <span >
                      <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title].split('T')[0]): '-'}}</span>
                      <span v-else-if="cl.datatype=='numeric'">{{(tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                      <span v-else-if="cl.datatype=='array'">
                        <span v-for="(co, indd) in tr[cl.title]" v-bind:key="'coname'+indd+ind+index">
                          {{co}} {{(indd < (tr[cl.title].length-1))? ', ':''}}
                        </span>
                      </span>
                      <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                    </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="rawDataType == 'scheme-returns'">
              <table :id="'mf'+rawDataType" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in schemeReturnTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >
                    <span>{{field.name}}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                    <td>
                      <span>{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in schemeReturnTableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                    <span v-if="cl.isLink">
                      <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                      <router-link class="a-btn" :to="'/mutual-funds/schemes/' + tr[cl.title]" target="_blank">{{tr[cl.title]}}</router-link>
                    </span>
                    <span v-else>
                      <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title].split('T')[0]): '-'}}</span>
                      <span v-else-if="cl.datatype=='numeric'">{{(tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                      <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                    </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length && rawDataType === 'scheme-ratio-stats'">
              <table :id="'mf'+rawDataType" class="table table-bordered fonts11 app-inner">
                <tbody v-for="(tr, ind) in tableFields" v-bind:key="'trBod'+'-'+ind">
                  <tr>
                    <th class="text-bold">{{tr.name}}</th>
                    <th class="text-bold" v-for="(tcl, ind) in tableColumns" v-bind:key="'trBod'+'-'+ind">{{tcl.name}}</th>
                  </tr>
                  <tr v-for="(sttr, ind1) in statsFields" v-bind:key="'trBod'+'-'+ind1">
                    <td>{{sttr.name}}</td>
                    <td
                      v-for="(cl, index) in tableColumns"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                    <span>{{getChecknFixed(rawData[tr.title][cl.title][sttr.title])}}</span><br/>
                    <span v-if="rawData[tr.title][cl.title]['sch_names'][sttr.title]">
                      <span v-for="(sch, ind2) in rawData[tr.title][cl.title]['sch_names'][sttr.title]" v-bind:key="'sch'+ind2+ind+sttr.title+index" :style="'display: flex;'">{{(ind2+1)+'.'}} {{sch}} </span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length && rawDataType === 'scheme-nav-historical'">
              <table :id="'mf'+rawDataType" class="table table-bordered fonts11 app-inner">
                <!-- <tbody v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                  <tr>
                    <th class="text-bold" >{{getDate(tr._id)}}</th>
                    <th class="text-bold"></th>
                  </tr>
                  <tr v-for="(nav, navInd) in tr.navs" v-bind:key="'trNav'+navInd">
                    <td v-for="(field, fieldKey) in tableFields" v-bind:key="'tdNav'+navInd+fieldKey">
                    <span v-if="field.datatype === 'date'">{{getDate(nav[field.title].split('T')[0])}}</span>
                    <span v-if="field.datatype === 'number'">{{getChecknFixed(nav[field.title])}}</span>
                    <span v-else>{{(nav[field.title])}}</span>
                    </td>
                  </tr>
                </tbody> -->
                <thead >
                  <tr>
                    <th v-for="(field, fieldKey) in tableFields" v-bind:key="'thnavhist'+fieldKey">
                      {{field.name}}
                    </th>
                  </tr>
                </thead>
                <tbody >
                  <tr v-for="(tr, ind) in rawData" v-bind:key="'trBod'+'-'+ind">
                    <td v-for="(field, fieldKey) in tableFields" v-bind:key="'tdNav'+ind+fieldKey">
                    <span v-if="field.datatype === 'date'">{{getDate(tr[field.title].split('T')[0])}}</span>
                    <span v-else-if="field.datatype === 'number'">{{getChecknFixed(tr[field.title])}}</span>
                    <span v-else-if="field.datatype === 'object'">{{(tr[field.title][0][field.subtitle])}}</span>
                    <span v-else>{{(tr[field.title])}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mb5 mt10 table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length && rawDataType === 'sector-historical'">
               <table class="table table-bordered font11" :id="'mf'+rawDataType">
                  <thead>
                      <th :class="ind == 0 ? 'scheme-column' : ''"  v-for="(field, ind) in tableFields" v-bind:key="'ratingth'+ind">{{field.title}}</th>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in rawData" v-bind:key="'ratingt'+ind">
                      <td v-for="(field, ci) in tableFields" v-bind:key="'sector' + ci">
                        <span v-if="field.data_type=='date'"> {{ item[ci][field.key] ? getDate(item[ci][field.key]) : '-' }} </span>
                        <span v-else-if="field.data_type=='numeric'">{{getChecknFixed(item[ci][field.key])}}</span>
                        <span v-else-if="field.data_type=='perc'">
                          {{ item[ci][field.key] ? getFixed2dec(item[ci][field.key]) + '%' : '-' }}
                        </span>
                        <span v-else>
                          {{ item[ci][field.key] }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div class="row mb5 mt10 table-responsive scrollbar app" v-dragscroll="true" v-if="tableFields.length && rawDataType === 'scheme-asset-allocation'">
              <table class="table table-bordered fonts11 app-inner" :id="'mf'+rawDataType">
                  <thead>
                    <tr>
                      <th  v-for="(field, ind) in tableFields" v-bind:key="'ratingth'+ind">{{field.title}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in rawData" v-bind:key="'ratingt'+ind">
                      <td v-for="(field, ci) in tableFields" v-bind:key="'sector' + ci">
                        <span v-if="field.data_type=='date'"> {{ item[ci][field.key] ? getDate(item[ci][field.key]) : '-' }} </span>
                        <span v-else-if="field.data_type=='numeric'">{{getChecknFixed(item[ci][field.key])}}</span>
                        <span v-else-if="field.data_type=='perc'">
                          {{ item[ci][field.key] ? getFixed2dec(item[ci][field.key]) + '%' : '-' }}
                        </span>
                        <span v-else-if="field.subKey == '_id'">
                          {{ item[ci][field.key] }}
                        </span>
                        <span v-else-if="field.key == 'Category'">
                          {{ item[ci][field.key] }}
                        </span>
                        <span v-else>
                          {{ item[ci][field.key] }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>
            <div class="row table-responsive scrollbar app" v-dragscroll="true" v-if="rawDataType == 'dashboard'"> 
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-10"></div>
                  <div class="col-md-2">
                    <download :tableId="'mfcat'+rawDataType" :fileName="rawDataType+'fundmng'"></download>
                  </div>
                </div>        
                <div class="table-responsive scrollbar app">
                  <table :id="'mfcat'+rawDataType" class="table table-bordered fonts11 app-inner">
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th
                          class="data-cell"
                          v-for="(field, index, key) in fundmngTableFields"
                          v-bind:key="'field'+field.rowind+index+key"
                        >
                        {{field.name}}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tr, ind) in rawData.fundmanagerwise" v-bind:key="'trBod'+'-'+ind">
                        <td><span>{{ind+1}}</span>
                        </td>
                        <td
                          v-for="(cl, index) in fundmngTableFields"
                          v-bind:key="index+'cldata'+cl.title"
                        >
                        <span v-if="cl.isLink">
                          <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                          <router-link class="a-btn" :to="'/mutual-funds/schemes/' + tr[cl.title]" target="_blank">{{tr[cl.title]}}</router-link>
                        </span>
                        <span v-else>
                          <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title].split('T')[0]): '-'}}</span>
                          <span v-else-if="cl.datatype=='numeric'">{{(tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                          <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                        </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-10"></div>
                  <div class="col-md-2">
                    <download :tableId="'mffund'+rawDataType" :fileName="rawDataType+'category'"></download>
                  </div>
                </div>        
                <div class="table-responsive scrollbar app">
                  <table :id="'mffund'+rawDataType" class="table table-bordered fonts11 app-inner">
                    <thead>
                      <tr>
                        <th>Sr.</th>
                        <th
                          class="data-cell"
                          v-for="(field, index, key) in catwiseTableFields"
                          v-bind:key="'catfield'+field.rowind+index+key"
                        >{{field.name}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tr, ind) in rawData.categorieswise" v-bind:key="'trCatBod'+'-'+ind">
                        <td><span>{{ind+1}}</span>
                        </td>
                        <td
                          v-for="(cl, index) in catwiseTableFields"
                          v-bind:key="index+'catcldata'+cl.title"
                        >
                        <span v-if="cl.isLink">
                          <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                          <router-link class="a-btn" :to="'/mutual-funds/schemes/' + tr[cl.title]" target="_blank">{{tr[cl.title]}}</router-link>
                        </span>
                        <span v-else>
                          <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title].split('T')[0]): '-'}}</span>
                          <span v-else-if="cl.datatype=='numeric'">{{(tr[cl.title])? getChecknFixed(tr[cl.title]): '-'}}</span>
                          <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                        </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row mb5 mt10 table-responsive scrollbar app" v-dragscroll="true" v-if="schemeReturnRankCols.length && rawDataType === 'scheme-return-ranks'">
              <table class="table table-bordered fonts11 app-inner" v-if="schemeReturnRanksDuration.length > 0">
                 
                    <!-- <tr>
                      <th style="padding: 10px 80px;">DURATION</th>
                      <th style="padding: 10px 30px;" class="text-center">TOTAL</th>
                    </tr>
                 
                    <tr v-for="(srDurationItem, ind1) in schemeReturnRanksDuration">
                      <td class="text-bold">{{srDurationItem['DURATION']}} </td>
                      <td class="text-center">{{srDurationItem['TOTAL']}} </td>
                    </tr> -->
                    <thead>
                      <tr>
                        <th class="text-center">DURATION</th>
                        <th v-for="(item, index) in schemeReturnRanksDuration" :key="'duration-' + index">
                          {{ item.DURATION }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th class="text-center p-0">TOTAL</th>
                        <td v-for="(item, index) in schemeReturnRanksDuration" :key="'total-' + index">
                          {{ item.TOTAL }}
                        </td>
                      </tr>
                    </tbody>
                 
              </table>
              <!-- schemeReturnRanksDuration -->
              <table class="table table-bordered fonts11 app-inner" :id="'mf'+rawDataType">
                <tbody v-for="(data, ind) in schemeReturnRanks" v-bind:key="'tbody'+ind">
                  <tr v-if="ind==0">
                    <!-- <th>{{data.schemeName}}</th> -->
                    <th style="padding: 10px 80px;">Duration</th>
                    <th style="padding: 10px 30px;" class="text-center">Date</th>
                    <th v-for="(th, ind1) in schemeReturnRankCols" v-bind:key="'thr'+'-'+ind1" colspan="2">{{th.title}}</th>
                  </tr>
                  <tr v-if="ind==0">
                    <th>Scheme Name</th>
                    <th></th>
                    <template v-for="(th, ind1) in schemeReturnRankCols">
                      <th v-bind:key="'rankTH'+'-'+ind1">
                        {{ 'Rank' }}
                      </th>
                       <th v-bind:key="'valueTH'+'-'+ind1">
                        {{ 'Value' }}
                      </th>
                    </template>
                  </tr>
                  <!-- {{ schemeReturnRankRows }} -->
                  <!-- <tr v-for="(tr, ind2) in schemeReturnRankRows" v-bind:key="'tr-'+ind2">
                    <td class="text-bold">{{tr.title}} ==>> </td>
                    <template v-for="(td, ind1) in schemeReturnRankCols">
                      <td v-bind:key="'trdRank'+'-'+ind1">
                        <span v-if="tr.dataType == 'numeric'">{{getFixed(data[td.title][tr.title])}}</span>
                        <span v-else>{{data[td.title]['RANK']}}</span>
                      </td>
                      <td v-bind:key="'trdValue'+'-'+ind1">
                        <span v-if="tr.dataType == 'numeric'">{{getFixed(data[td.title][tr.title])}}</span>
                        <span v-else>{{data[td.title]['VALUE']}}</span>
                      </td>
                    </template>
                  </tr> -->
                   <tr>
                    <td class="text-bold">{{data.schemeName}} </td>
                    <td class="text-center">{{getDate(data.date)}} </td>
                    <template v-for="(td, ind1) in schemeReturnRankCols">
                      <td v-bind:key="'trdRank'+'-'+ind1">
                        <span >{{data[td.title]['RANK']}}</span>
                      </td>
                      <td v-bind:key="'trdValue'+'-'+ind1">
                        <span >{{getFixed(data[td.title]['VALUE'])}}</span>
                      </td>
                    </template>
                  </tr>
                  <!-- <tr>
                    <td class="text-bold">Total</td>
                    <td class="text-bold" v-for="(td, ind1) in schemeReturnRankCols" v-bind:key="'trd'+'-'+ind1">
                     {{td.total.TOTAL}}
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>
            <div class="row mb5 mt10 " v-if="tableFields.length && rawDataType === 'type-master' && typeMasterCategories != null">
              <div class="col-md-10"></div>
              <div class="col-md-2">
                <download :tableId="'mf-category-'+rawDataType" :fileName="'category'+rawDataType"></download>
              </div>
              <div class="col-md-12 table-responsive scrollbar app" v-dragscroll="true" >
              <table class="table table-bordered fonts11 app-inner" :id="'mf-category-'+rawDataType">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>Sub-Categories</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, ind) in Object.keys(typeMasterCategories)" v-bind:key="'tbody'+ind">
                    <td class="text-bold">{{data}} </td>
                      <td >
                        <span v-for="(typeData, ind1) in typeMasterCategories[data]" v-bind:key="ind+'tr'+ind1">{{typeData}}
                          {{(ind1 < (typeMasterCategories[data].length-1))? ', ': ''}}
                        </span>
                      </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
            <!--------PAGINATION------------>
            <div class="row">
                <div class="col-md-7"></div>
                <div class="col-md-5">
                <div class="pull-right">
                <ul v-if="totalPages != 1" class="pagination">
                  <li :class="{disabled:prevDisabled}" class="page-item">
                    <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
                  </li>
                  <li :class="{disabled:prevDisabled}" class="page-item">
                    <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
                  </li>
                  <li
                    v-for="page in pages"
                    v-bind:key="page"
                    class="page-item"
                    :class="(current_page == page)? 'active':''"
                  >
                    <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                  </li>
                  <li :class="{disabled:nextDisabled}" class="page-item">
                    <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
                  </li>
                  <li :class="{disabled:nextDisabled}" class="page-item">
                    <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
                  </li>
                </ul>
              </div>
            </div>
            </div>
            <div class="row mb5" v-if="!tableFields.length && rawDataType != 'dashboard'">
              <div class="col-md-12"><div class="alert alert-danger" role="alert">No data found!</div></div>
            </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  components: { VueTabs, VTab, Datepicker},
  mixins: [commonMixins, rawMixins],
  created() {
    this.rawDataType = this.rawDataList[this.selRowInd].id;
    localStorage.setItem("mutualTab", this.rawDataType);
    localStorage.setItem("selMutualTab", this.selMutualTab);
    this.getRawData();
    this.loadInitialData();
    console.log("Rawtype", this.rawDataType, this.selMutualTab);
  },
  methods: {
    getRawData(arg) {
      if(arg ==1){
        this.page = 1;
        this.current_page = 1;
      }
      if(!this.isApiCalled) {
        this.isApiCalled = 1;
        let myself = this;
        let apiUrl = this.rawDataApi+this.rawDataType;
        if(!this.isDownload) {
          this.rawData = [];
          this.tableFields = this.catwiseTableFields = this.fundmngTableFields = [];
          this.actions = [];
          this.totalPages = 1;
        }
        console.log("##getRawData##",this.rawDataType);
        if(this.rawDataList[this.selRowInd].isPaginate) {
          apiUrl = apiUrl + '?page=' +this.page;
          if(this.durDate!=null) {
            apiUrl = apiUrl + '&date=' + this.getYMDDate(this.durDate);
            if (this.isDownload === 1) {
              apiUrl = apiUrl + '&download=1';
            }
          } else {
            if (this.isDownload === 1) {
              apiUrl = apiUrl + '&download=1';
            }
          }
        } else {
          if(this.durDate!=null && this.rawDataType !== 'scheme-nav-historical') {
            apiUrl = apiUrl + '?date=' + this.getYMDDate(this.durDate);
            if (this.isDownload === 1) {
              apiUrl = apiUrl + '&download=1';
            }
          } else {
            if (this.isDownload === 1) {
              apiUrl = apiUrl + '?download=1';
            }
          }
        }
        if(this.rawDataType=='scheme-nav-latest' || this.rawDataType=='scheme-nav-historical') {
          // apiUrl = apiUrl + '?page=' +this.page;
          if(this.selFundManager != null && this.selFundManager.fund_manager){
            console.log(this.selFundManager);
            apiUrl = apiUrl + '&fund_manager=' + this.selFundManager.fund_manager;
          }
          if(this.scheme_name != ''){
            apiUrl = apiUrl + '&scheme_name=' + encodeURIComponent(this.scheme_name);
          }
          if(this.category != ''){
            apiUrl = apiUrl + '&category=' + this.category;
          }
          if(this.lname != ''){
            apiUrl = apiUrl + '&lname=' + this.lname;
          }
        } else if(this.rawDataType == 'fund-wise-monthly-aum'){
          if(this.amc_name != ''){
            if(this.durDate || this.isDownload === 1) {
              apiUrl = apiUrl + '&amc_name=' + this.amc_name;
            } else {
              apiUrl = apiUrl + '?amc_name=' + this.amc_name;
            }
          }
        } else if(this.rawDataType == 'scheme-returns'){
          if(!this.isDownload) {
            if(this.scheme_name != ''){
              apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
            }
            if(this.scheme_class != ''){
              apiUrl = apiUrl + '&schemeClassCode=' + this.scheme_class;
            }
          }
        } else if(this.rawDataType == 'scheme-ratios') {
          if(!this.isDownload) {
            if(this.scheme_name != '') {
              apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
            }
            if(this.scheme_class != ''){
              apiUrl = apiUrl + '&schemeClassCode=' + this.scheme_class;
            }
            if(this.category != '') {
              apiUrl = apiUrl + '&category=' + this.category;
            }
            if(this.sort != '' && this.sortOrder != '') {
              apiUrl = apiUrl + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder;
            }
          }
        } else if(this.rawDataType == 'avg-maturity-data') {
          if(!this.isDownload) {
            if(this.scheme_name != '') {
              apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
            }
            if(this.scheme_class != ''){
              apiUrl = apiUrl + '&schemeClassCode=' + this.scheme_class;
            }
            if(this.category != '') {
              apiUrl = apiUrl + '&category=' + this.category;
            }
            if(this.sort != '' && this.sortOrder != ''){
              apiUrl = apiUrl + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder;
            }
          }
        } else if(this.rawDataType == 'scheme-master-info') {
          if(this.scheme_name != '') {
            apiUrl = apiUrl + '?scheme_name=' + this.scheme_name;
          }
        } else if(this.rawDataType == 'category-wise-returns') {    
          if(!this.isDownload) {
            if(this.scheme_class != ''){
              if(this.durDate) {
                apiUrl = apiUrl + '&schemeClassCode=' + this.scheme_class;
              } else {
                apiUrl = apiUrl + '?schemeClassCode=' + this.scheme_class;
              }
            }
          }
        } else if(this.rawDataType == 'scheme-return-ranks') {
          // apiUrl = apiUrl + '&groupBy=1';
          if(!this.isDownload) {
            if(this.scheme_name != '') {
              apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
            }
            if(this.scheme_class != ''){
              apiUrl = apiUrl + '&schemeClassCode=' + this.scheme_class;
            }
          }
        } else if(this.rawDataType == 'scheme-asset-allocation') {
          if(!this.isDownload) {
            if(this.scheme_name != '') {
              apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
            }
            if(this.scheme_class != ''){
              apiUrl = apiUrl + '&schemeClassCode=' + this.scheme_class;
            }
            if(this.category != '') {
              apiUrl = apiUrl + '&category=' + this.category;
            }
          }
          console.log('GroupBy');
          apiUrl = apiUrl + '&groupBy=1';
        } else if(this.rawDataType == 'sector-historical') {
          console.log('schemeClassCode');
          if(!this.isDownload) {
            if(this.schemeClassCode!='') {
              apiUrl = apiUrl + '&schemeClassCode='+this.schemeClassCode;
            } else {
              apiUrl = apiUrl + '&schemeClassCode=1';
            }
            if(this.sector_search) {
              apiUrl = apiUrl + '&sector='+this.sector_search;
            }
            apiUrl = apiUrl + '&groupBy=1';
          }
        } else if(this.rawDataType == 'scheme-nav-historical') {
          if(!this.isDownload) {
          if(this.schemeClassCode!='') {
              if(this.durDate) {
                apiUrl = apiUrl + '&schemeClassCode=' + this.schemeClassCode;
              } else {
                apiUrl = apiUrl + '&schemeClassCode=' + this.schemeClassCode;
              }
            }
          }
        } else if(this.rawDataType == 'scheme-aum') {
          if(!this.isDownload) {
            if(this.scheme_name != '') {
              apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
            }
            if(this.category != '') {
              apiUrl = apiUrl + '&category=' + this.category;
            }
            if(this.sort != '' && this.sortOrder != ''){
              apiUrl = apiUrl + '&sort=' + this.sort + '&sortOrder=' + this.sortOrder;
            }
          }
        } else if(this.rawDataType == 'whats-in-out') {
          if(this.scheme_name != '') {
            apiUrl = apiUrl + '&scheme_name=' + this.scheme_name;
          }
          if(this.scheme_class != ''){
            apiUrl = apiUrl + '&schemeClassCode=' + this.scheme_class;
          }
          apiUrl = apiUrl + '&groupBy=1';
        }
        console.log('APIURL', apiUrl);
        http.get(
          apiUrl,
          {},
          (error, response) => {
            console.log("Response",this.rawDataType, response);
            if(response && (response.status == 'success' || response.message == 'success') && response.data != null) {
              this.last_updated_date = '';
              if('last_updated_date' in response && response.last_updated_date) {
                this.last_updated_date = response.last_updated_date.split('T')[0];
              } else if('date' in response && response.date) {
                this.last_updated_date = response.date.split('T')[0];
              } else if('date' in response.data && response.data.date) {
                this.last_updated_date = response.data.date.split('T')[0];
              } else if('CurrentMonth' in response && response.CurrentMonth) {
                this.last_updated_date = response.CurrentMonth.split('T')[0];
              }
              if (this.rawDataType === "fund-houses")  {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='STARTED_ON' || tf == 'dateas')? 'date': '',
                        sort_order: (tf=='MF_COCODE')? 1: (tf=='nameamc')? 2
                        : (tf=='LNAME')? 3
                        : (tf=='STARTED_ON')? 4                        
                        : (tf=='FUND_TYPE')? 4
                        : (tf=='dateas')? 5  
                        : (tf=='SumOfTOTNAV')? 6
                        : (tf=='dateas')? 7
                        : (tf=='website')? 8
                        : (tf=='address')? 9
                        : (tf=='email')? 10
                        : (tf=='telephone')? 11
                        : (tf=='csch')? 12
                        : (tf=='isch')? 13
                        : (tf=='osch')? 14
                        : 99
                      });
                    }
                  });
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }
              } else if(this.rawDataType === "schemes") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: tf,
                        isLink: (tf=='mf_schcode')? 1: 0,
                        datatype: (tf=='LaunchDate' || tf=='navdate')? 'date': '',
                        sort_order: (tf=='MF_COCODE')? 1: (tf=='mf_schcode')? 2: (tf=='Category')? 3
                        : (tf=='MCAPCategory')? 4
                        : (tf=='mf_schname' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name')? 5 
                        : (tf=='LNAME')? 5
                        : (tf=='LaunchDate')? 6
                        : (tf=='FundManager')? 7
                        : (tf=='SchemeAUM')? 8
                        : (tf=='navrs')? 9
                        : (tf=='frequency')? 10
                        : (tf=='navdate')? 11
                        : (tf=='InvestmentType')? 12
                        : (tf=='FundType')? 13
                        : (tf=='ClassCode')? 14
                        : (tf=='EntrytLoad')? 15
                        : (tf=='MinInvestment')? 16
                        : (tf=='MinInvestment_SIP')? 17
                        : (tf=='IncrementalInvestment')? 18
                        : (tf=='ExitLoad')? 19
                        : (tf=='isin')? 20
                        : (tf=='isin_Reinvestment')? 21
                        : (tf=='rtcode')? 22
                        : (tf=='amficode')? 23
                        : 99,                    
                      });
                    }
                    this.actions = [{
                        btnClass: "btn-primary",
                        icon: "",
                        callback: this.showSchemeHoldings,
                        tooltip: "Holdings",
                        isLink: 1,
                        url: '/mutual-funds/schemeholdings/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-warning",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Ratios",
                        isLink: 1,
                        url: '/mutual-funds/schemeratios/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-success",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Profile Exp Ratios",
                        isLink: 1,
                        url: '/mutual-funds/schemeprofileexpratios/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-primary",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Analysis",
                        isLink: 1,
                        url: '/mutual-funds/analysis/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-info",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Analysis Sum",
                        isLink: 1,
                        url: '/mutual-funds/analysis-sum/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }, {
                        btnClass: "btn-secondary",
                        icon: "",
                        callback: this.showSchemeRatios,
                        tooltip: "Holding Mix",
                        isLink: 1,
                        url: '/mutual-funds/schemes/',
                        param: 'mf_schcode',
                        isNewWindow: 1,
                      }]
                  });
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                }
              
              } else if(this.rawDataType === "scheme-master-info") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='Launc_Date' || tf =='CLDATE')? 'date': '',
                        sort_order: (tf=='Mf_SchCode')? 1
                        : (tf=='Sch_Name')? 2
                        : (tf=='mf_schname' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name')? 2 
                        : (tf=='SCHEME')? 3
                        : (tf=='LName')? 4
                        : (tf=='SIZE')? 5
                        : (tf=='Launc_Date')? 6
                        : (tf=='TypeName')? 7
                        : (tf=='VClassCode')? 8
                        : (tf=='VClass')? 9
                        : (tf=='MININVT')? 10
                        : (tf=='OFFERPRICE')? 11
                        : (tf=='CLDATE')? 12
                        : (tf=='Objective')? 13
                        : 13
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }
              } else if(this.rawDataType === "category-wise-returns") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='CategoryReturnDate')? 'date':(tf!='classcode' && tf!='typename')? 'numeric': '',
                        sort_order: (tf=='classcode')? 1: (tf=='typename')? 2 
                        : (tf=='CategoryReturnDate')? 2
                        : (tf=='ret1m')? 4
                        : (tf=='ret1w')? 3
                        : (tf=='ret3m')? 5
                        : (tf=='ret6m')? 6
                        : (tf=='ret1y')? 7
                        : (tf=='ret3y')? 8
                        : (tf=='ret5y')? 9
                        : 13
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }
              } else if(this.rawDataType === "amfi") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf-='CurrPFDate')? 'date': '',
                        sort_order: (tf=='mf_Schcode')? 1: (tf=='amficode')? 2 : 3
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }
              } else if(this.rawDataType === "sector-historical") {
                this.rawData = [];
                this.searchData = this.rawData;
                if(response.data) {
                    for(const [index, [key, value]] of Object.entries(Object.entries(response.data))) {
                      if(index==0){
                        this.tableFields = [{data_type: '', key: 'Holding', title: 'Holding'}];
                        var dataType = 'perc';
                        var title = '';
                        for(let th of Object.keys(value)) {
                          title = th;
                          if(th == 'scheme_class_code' || th == 'scheme_class_name') {
                            dataType = 'string';
                            title = this.getLabel(th);
                          }
                          const thData = {data_type: dataType, key: th, title: title};
                          this.tableFields.push(thData);
                        }
                      }
                      this.rawData[index] = [];
                      this.tableFields.forEach((item,ci) => {
                        if(item.key == 'Holding') {
                          this.rawData[index].push({[item.key]: key});
                        } else {
                          this.rawData[index].push({[item.key]: value[item.key]});
                        }
                      })
                    }
                }
                this.rawData.reverse(); 
              } else if(this.rawDataType === "scheme-nav-latest") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate' || tf=='NAVDATE')? 'date': '',
                        sort_order: (tf=='mf_schcode')? 1
                        : (tf=='mf_schname' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name')? 2 
                        : (tf=='navdate')? 3
                        : (tf=='Tax_Type')? 4
                        : (tf=='ISIN')? 5
                        : (tf=='NAV')? 6
                        : (tf=='SellNav')? 7 
                        : (tf=='RePurchaseNAV')? 8 
                        : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }
              } else if(this.rawDataType === "scheme-returns") {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                    
                }
              } else if(this.rawDataType === 'fund-wise-monthly-aum') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='AUMDate')? 'date': '',
                        sort_order: (tf=='AMCCode')? 2
                        : (tf=='AMCName')? 3 
                        : (tf=='AUM')? 4
                        : (tf=='AUMDate')? 1
                        : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }
              } else if(this.rawDataType == 'scheme-ratios') {                
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (this.checkInArray(['navdate','corpus_date','inception_date', 'DATE', 'date'], tf.toLowerCase()))? 'date'
                        :(this.checkInArray(['Corpus', 'NAV', 'ALPHA', 'AVERAGE', 'BETA', 'RSQUARE', 'SHARPE', 'TREYNOR'], tf))? 'numeric'
                        : '',
                        sort: (this.sort == tf)? (this.sortOrder == 'DESC')? 2:  (this.sortOrder == 'ASC')? 1: '0':'',  
                        isSortable: (this.checkInArray(['Corpus', 'NAV', 'ALPHA', 'AVERAGE', 'BETA', 'RSQUARE', 'SHARPE', 'TREYNOR', 'SD'], tf))? 1: 0,  
                        sort_order: (tf=='MF_SCHCODE')? 2
                          : (tf.toLowerCase()=='category')? 5
                          : (tf.toLowerCase()=='inception_date')? 6
                          : (tf.toLowerCase()=='scheme_nam')? 3
                          : (tf.toLowerCase()=='date')? 4
                          : (tf=='Corpus')? 7
                          : (tf=='Corpus_Date')? 8
                          : (tf=='NAV')? 9
                          : (tf=='ALPHA')? 10
                          : (tf=='AVERAGE')? 11
                          : (tf=='BETA')? 12
                          : (tf=='RSQUARE')? 13
                          : (tf=='SHARPE')? 14
                          : (tf=='TREYNOR')? 15
                          : (tf=='SD')? 16
                          : 99
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }
              } else if(this.rawDataType == 'type-master') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.typeMasterCategories = response.category_wise_data;
                console.log(this.typeMasterCategories);
                this.rawData = this.sorted_fields_asc(this.rawData, "TYPECODE");
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: (tf=='TYPECODE')? 1
                          : (tf=='TYPE')? 2 
                          : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);  
                }          
              } else if(this.rawDataType == 'dashboard') {
                this.rawData = (response.data)? response.data: [];
                if(response.data && response.data.categorieswise) {
                  if(response.data.categorieswise.length) {
                    var catwise = Object.keys(response.data.categorieswise[0]);
                    var catwiseTableFields = [];
                    catwise.forEach((tf, key) => {
                      catwiseTableFields.push({
                        title: tf,
                        name: (tf=='_id')? 'Name': (tf=='count')? 'Total': this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: (tf=='_id')? 1
                        : (tf=='count')? 2 
                        : 10
                      });
                    });
                    this.catwiseTableFields = catwiseTableFields;
                    this.rawData.categorieswise = this.sorted_fields_asc(this.rawData.categorieswise, "_id");
                  }
                }
                if(response.data && response.data.fundmanagerwise){
                  if(response.data.fundmanagerwise.length) {
                    var fundwise = Object.keys(response.data.fundmanagerwise[0]);
                    var fundmngTableFields = [];
                    fundwise.forEach((tf, key) => {
                      fundmngTableFields.push({
                        title: tf,
                        name: (tf=='_id')? 'Name': (tf=='count')? 'Total': this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: (tf=='_id')? 1
                        : (tf=='count')? 2 
                        : 10
                      });
                    });
                    this.fundmngTableFields = fundmngTableFields;
                    this.rawData.fundmanagerwise = this.sorted_fields_asc(this.rawData.fundmanagerwise, "_id");
                  }
                }

              } else if(this.rawDataType == 'avg-maturity-data') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id' && tf != 'scheme_info') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='last_updated' || tf=='AvgMaturityDate')? 'date': (tf=='sch_name')? 'array':'',
                        sort_order: (tf=='mf_schcode')? 1
                        : (tf=='sch_name' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name')? 2 
                        : (tf =='scheme_class_name')? 3
                        : (tf=='last_updated')? 4
                        : 10
                      });
                    }
                  })
                }
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
              } else if(this.rawDataType == 'activities') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='TRANS_DATE')? 'date': '',
                        sort_order: (tf=='TRANS_DATE')? 1
                        : (tf=='DE_GR_PURC')? 2
                        : (tf=='DE_GR_SALE')? 3
                        : (tf=='DB_G_NE_PS')? 4
                        : (tf=='EQ_GR_PURC')? 5
                        : (tf=='EQ_GR_SALE')? 6
                        : (tf=='EQ_G_NE_PS')? 7
                        : 8
                      });
                    }
                  })
                }
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
              } else if(this.rawDataType == 'sip-dates') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id' && tf != 'scheme_class_code') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='TRANS_DATE')? 'date': '',
                        sort_order: (tf=='MF_COCODE')? 1
                        : (tf=='MF_SCHCODE')? 2
                        : (tf=='mf_schname' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name')? 2 
                        : (tf =='scheme_class_name')? 2
                        : (tf=='PLAN')? 3
                        : (tf=='Frequency')? 4
                        : (tf=='MinAmt')? 5
                        : (tf=='D1')? 6
                        : (tf=='D2')? 7 
                        : (tf=='D3')? 8
                        : (tf=='D4')? 9
                        : (tf=='D5')? 10
                        : (tf=='D6')? 11
                        : (tf=='D7')? 12
                        : (tf=='D8')? 13
                        : (tf=='D9')? 14
                        : (tf=='D10')? 15
                        : (tf=='ANY')? 16
                        : 19
                      });
                    }
                  })
                }
                this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                console.log(this.tableFields);
              } else if(this.rawDataType == 'dividend-details') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='NAVDATE' || tf=='DivDate' || tf=='RecordDate')? 'date'
                          : (this.checkInArray(['ONE_WEEK','ONE_MONTH','THREE_MONTH', 'SIX_MONTH', 'ONE_YEAR', 'THREE_YEAR', 'FIVE_YEAR'], tf))? 'numeric': '',
                        sort_order: (tf=='MF_COCODE')? 1
                          : (tf=='Mf_SchCode')? 2 
                          : (tf=='mf_schname' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name' || tf == 'Sch_Name')? 3 
                          : (tf=='LName')? 4
                          : (tf=='VClassCode')? 5
                          : (tf=='VClass')? 6
                          : (tf=='TypeName')? 7 
                          : (tf=='NAVRS')? 8
                          : (tf=='NAVDATE')? 9
                          : (tf=='Divtype')? 10
                          : (tf=='DivDate')? 11
                          : (tf=='DIVTYPCODE')? 12
                          : (tf=='DivPer')? 13
                          : (tf=='DIVPERPU')? 14
                          : (tf=='DivAmount')? 15
                          : (tf=='ONE_WEEK')? 16
                          : (tf=='ONE_MONTH')? 17
                          : (tf=='THREE_MONTH')? 18
                          : (tf=='SIX_MONTH')? 19
                          : (tf=='ONE_YEAR')? 20
                          : (tf=='THREE_YEAR')? 21
                          : (tf=='FIVE_YEAR')? 22
                          : (tf=='RecordDate')? 15
                          : 29
                      });
                    }
                  })
                }
                this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                console.log(this.tableFields);
              } else if(this.rawDataType === "scheme-asset-allocation") {
                  if(response.status === "success"){
                    this.rawData = [];
                    this.searchData = this.rawData;
                    if(response.data.length > 0) {
                        this.tableFields = [];
                        for(const [index, [key, value]] of Object.entries(Object.entries(response.data))) {
                          // console.log('index', index, 'key', key, 'value', value); 
                            if(index==0) {
                              this.tableFields = [{data_type: '', subKey: '_id', key: 'Holding', title: 'Scheme'},{data_type: '', subKey: 'Category', key: 'Category', title: 'Category'}];
                              let colInd = 0;
                              for(const asstname of value['AssetName']) {
                                // console.log('asstname', asstname);
                                let thData1 = {data_type: 'perc', colInd: colInd, subKey: 'Holding_CurrentMonth',  key: 'Holding_CurrentMonth_'+asstname, title: asstname + ' (' + this.getDDMonthYear(response.CurrentMonth.split('T')[0])+ ')' };
                                this.tableFields.push(thData1);
                                // let thData2 = {data_type: 'perc', colInd: colInd,  subKey: 'Holding_PrevMonth', key: 'Holding_PrevMonth_'+asstname, title: 'Holding_PrevMonth_'+asstname};
                                // this.tableFields.push(thData2);
                                colInd++
                              }
                              let colInd1 = 0;
                              for(const asstname of value['AssetName']) {
                                // console.log('asstname', asstname);
                                // let thData1 = {data_type: 'perc', colInd: colInd, subKey: 'Holding_CurrentMonth',  key: 'Holding_CurrentMonth_'+asstname, title: 'Holding_CurrentMonth_'+asstname};
                                // this.tableFields.push(thData1);
                                let thData2 = {data_type: 'perc', colInd: colInd1,  subKey: 'Holding_PrevMonth', key: 'Holding_PrevMonth_'+asstname, title: asstname+' (Prev. month)'};
                                this.tableFields.push(thData2);
                                colInd1++
                              } 
                            }
                            this.rawData[index] = [];
                            this.tableFields.forEach((item, ci) => {
                              // console.log('tableFields', index, ci, value);
                              if(item.key == 'Holding' || item.key == 'Category') {
                                this.rawData[index].push({[item.key]: value[item.subKey]});
                              } else {
                                this.rawData[index].push({[item.key]: value[item.subKey][item.colInd]});
                              }
                            })
                        }
                        console.log('tableFields', this.tableFields);
                        console.log('rawData', this.rawData);
                        // console.log('tableFields length', this.tableFields.length);
                        // console.log('rawData', this.rawData);
                    }
                    // console.log('rawData===>>', this.rawData);
                    // console.log('tableFields<<<<>>>>>', this.tableFields);
                  } else if(response.responseType === 'success') {
                      this.isDownload = 0;
                      this.isApiCalled = 0;
                      window.open(response.download_link, '_blank');
                  }
              } else if(this.rawDataType === 'scheme-aum') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id' && tf != 'scheme_class_code') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='AUMDate')? 'date': '',
                        sort_order: (tf=='mf_schcode' || tf=='MF_SCHCODE')? 1
                        : (tf=='mf_schname' || tf=='mf_schname' || tf=='SCH_NAME' || tf == 'sch_name')? 2
                        : (tf =='scheme_class_name')? 3
                        : (tf=='AUM')? 5
                        : (tf=='AUMDate')? 4 
                        : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }              
              }  else if(this.rawDataType == 'scheme-ratio-stats') {
                  this.rawData = response.data ? response.data: [];
                  console.log(response.data, this.rawData);
                  var tableKeys = Object.keys(this.rawData);
                  // this.rawData.forEach((rdataVal, rdatakey) => {
                  //   console.log(rdataVal, rdatakey);
                  // });
                  console.log(tableKeys);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id' && tf != 'date') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: key
                      });
                    }
                  });
                  console.log(this.tableFields);
                  var tableColumns = Object.keys(this.rawData[this.tableFields[0].title]);
                  console.log(tableColumns);
                  tableColumns.forEach((tf, key) => {
                    if(tf != '_id' && tf != 'date') {
                      this.tableColumns.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: key
                      });
                    }
                  });
                  console.log(this.tableColumns);
              } else if (this.rawDataType == 'category-amcwise') {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: (tf=='VCLASSCODE')? 1
                        : (tf=='VCLASS')? 2 
                        : (tf=='MainCategory')? 3
                        : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  this.rawData = this.sorted_fields_asc(this.rawData, "VCLASSCODE");
                  console.log(this.tableFields);
                }              
              } else if(this.rawDataType === 'scheme-nav-historical') {
                if (response.status === 'success') {
                  this.rawData = response.data.length > 0 ? response.data : [];
                  // this.scheme_class_codes = response.scheme_class_codes
                  this.searchData = this.rawData;
                  console.log(this.rawData);
                  if(response.data.length > 0) {
                    this.tableFields = 
                      [
                        {
                          title: 'sch_name',
                          name: 'scheme',
                          datatype: 'string',
                          sort_order: 1
                        },
                        {
                          title: 'scheme_info',
                          name: 'Category',
                          subtitle: 'Category',
                          datatype: 'object',
                          sort_order: 1
                        },
                        {
                          title: 'NAVDATE',
                          name: 'Nav Date',
                          datatype: 'date',
                          sort_order: 3
                        },
                        {
                          title: 'FLAG',
                          name: 'Flag',
                          datatype: 'string',
                          sort_order: 4
                        },
                        {
                          title: 'NAVRS',
                          name: 'NAV RS.',
                          datatype: 'number',
                          sort_order: 5
                        },
                        {
                          title: 'NAVREPRICE',
                          name: 'NAV RE RS.',
                          datatype: 'number',
                          sort_order: 6
                        },
                        {
                          title: 'NAVLSPRICE',
                          name: 'NAV LS Price',
                          datatype: 'number',
                          sort_order: 7
                        },
                        {
                          title: 'NAVSAPRICE',
                          name: 'NAV SA PRICE',
                          datatype: 'number',
                          sort_order: 8
                        },
                        {
                          title: 'ADJNAVRS',
                          name: 'ADJ NAV RS',
                          datatype: 'string',
                          sort_order: 9
                        },
                        {
                          title: 'NAVRS',
                          name: 'NAV RS.',
                          datatype: 'number',
                          sort_order: 10
                        },
                        {
                          title: 'BSE_SENSEX',
                          name: 'BSE SENSEX',
                          datatype: 'number',
                          sort_order: 11
                        },
                        {
                          title: 'BSE_500',
                          name: 'BSE 500',
                          datatype: 'number',
                          sort_order: 12
                        },
                        {
                          title: 'RC',
                          name: 'RC',
                          datatype: 'number',
                          sort_order: 13
                        },
                        {
                          title: 'SC',
                          name: 'SC.',
                          datatype: 'number',
                          sort_order: 14
                        }
                      ];
                  }
                } else {
                  console.log(response);
                  if(response.responseType === 'success') {
                    this.isDownload = 0;
                    window.open(response.download_link, '_blank');
                  }
                }
              } else if (this.rawDataType == 'scheme-return-ranks') {
                this.rawData = response.data.length > 0 ? response.data : [];
                console.log(this.rawData);
                this.schemeReturnRanks = [];
                if(response.data.length>0) {
                  var tableCols = [];
                  var tableRows = [{ title: 'VALUE', name: 'Value', dataType: 'numeric'}, { title: 'RANK', name: 'Rank', dataType: 'string'}];
                  this.schemeReturnRankRows = tableRows;
                  if(response.durations) {
                    //console.log('### duration_total  ####', response.duration_total)
                    if(response.totals != undefined){
                      /* this.schemeReturnRanksDuration = response.duration_total.sort((a, b) =>
                        a.DURATION.localeCompare(b.DURATION, undefined, { numeric: true })
                      ); */
                      this.schemeReturnRanksDuration = response.totals.reverse();
                      //console.log('@@@@@ ### duration_total  #### @@@@', response.duration_total)
                    }else{
                      this.schemeReturnRanksDuration = [];
                    }
                    response.durations.forEach((durVal, durKey) => {
                      tableCols[durKey] = {title: durVal,total: {}};
                      response.totals.forEach((totalVal) => {
                        if(totalVal.DURATION === durVal) {
                          tableCols[durKey]['total'] = totalVal;
                        }
                      });
                    });
                    this.schemeReturnRankCols = tableCols;
                    var tableData = [];
                    response.data.forEach((rankVal, rankKey) => {
                      tableData[rankKey] = {schemeName: rankVal.sch_name, date: rankVal.DATE};
                      response.durations.forEach((durVal, durKey) => {
                        rankVal.DURATION.forEach((rankDurVal, rankDurKey) => {
                          if(rankDurVal === durVal) {
                            tableData[rankKey][durVal] = {DURATION: rankDurVal, RANK: rankVal.RANK[rankDurKey], VALUE: rankVal.VALUE[rankDurKey]}; 
                          }
                        });
                      });
                    });
                  }
                  console.log(tableData, tableCols);
                  this.schemeReturnRanks = (tableData);
                  console.log(this.schemeReturnRankCols, this.schemeReturnRanks);
                }
              } else if(this.rawDataType == 'whats-in-out'){
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  this.tableFields = [{
                        title: 'scheme_name',
                        name: 'Scheme Name',
                        rowind: 0,
                        datatype: 'string',
                      },
                      {
                        title: 'category',
                        name: 'Category',
                        rowind: 0,
                        datatype: 'string',
                      },
                      {
                        title: 'in',
                        name: 'IN',
                        rowind: 0,
                        datatype: 'array',
                      },
                      {
                        title: 'out',
                        name: 'OUT',
                        rowind: 0,
                        datatype: 'array',
                      }];
                  response.data.forEach((tf, key) => {
                    this.rawData[key] = { scheme_name: tf.scheme_name, category: tf.scheme_name };
                    if(tf.data.length) {
                      var inData = [];
                      var outData = [];
                      tf.data.forEach((inoutVal, inoutKey) => {
                        console.log(inoutVal.direction, inoutVal.CO_NAME, inoutVal.direction == 'Out', inoutVal.direction == 'In');
                        if(inoutVal.direction == 'Out') {
                          outData.push(inoutVal.CO_NAME);
                        }
                        if(inoutVal.direction == 'In') {
                          inData.push(inoutVal.CO_NAME);
                        }
                        console.log(inData, outData);
                      });
                      console.log(inData, outData);
                      this.rawData[key]['in'] = inData;
                      this.rawData[key]['out'] = outData;
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields, this.rawData);
                }              
              } else {
                this.rawData = response.data.length > 0 ? response.data : [];
                this.searchData = this.rawData;
                console.log(this.rawData);
                if(response.data.length>0) {
                  var tableKeys = Object.keys(this.rawData[0]);
                  tableKeys.forEach((tf, key) => {
                    if(tf != '_id') {
                      this.tableFields.push({
                        title: tf,
                        name: this.getCustomLabel(tf)? this.getCustomLabel(tf): this.getLabel(tf),
                        rowind: 0,
                        datatype: (tf=='navdate')? 'date': '',
                        sort_order: (tf=='mf_schcode')? 1
                        : (tf=='mf_schname' || tf=='SCH_NAME')? 2 
                        : (tf=='navdate')? 3
                        : (tf=='Tax_Type')? 4
                        : (tf=='ISIN')? 5
                        : (tf=='NAV')? 6
                        : (tf=='SellNav')? 7 
                        : (tf=='RePurchaseNAV')? 8 
                        : 10
                      });
                    }
                  })
                  this.tableFields = this.sorted_fields_asc(this.tableFields, "sort_order");
                  console.log(this.tableFields);
                }              
              }
            // console.log("this.rawData", this.rawData);
            this.rawDataList[this.selRowInd].items = this.rawData;
            if(response.total_pages) {
              myself.perPage = myself.rawData.length;
                myself.totalPages = response.total_pages ? response.total_pages : 1;
                let i = 8;
                let page = myself.current_page - 2;
                if (page <= 0) page = 1;
                myself.pages = [];
                while (i) {
                  myself.pages.push(parseInt(page));
                  if (myself.totalPages <= page) break;
                  page++;
                  i--;
                }
            }
            this.isApiCalled = 0;
            //TODO:: add company updates into our array in future
            } else if(response && response.status == 'error') {
                this.isApiCalled = 0;
                this.isDownload = 0;
            } else {
              console.log(this.checkInArray(this.allDownloadTabs, this.rawDataType), response);
              if(this.checkInArray(this.allDownloadTabs, this.rawDataType) && response && response.responseType === 'success') {
                this.isDownload = 0;
                this.isApiCalled = 0;
                window.open(response.download_link, '_blank');
                // this.getRawData();
              } else {
                console.log('Some error in API call');
                this.isApiCalled = 0;
                this.isDownload = 0;
              }
            }
            //console.log('########### error ########', error)
            if(error != null){
              this.isDownload = 0;
            }
          });
      }
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(this.selRowInd, tabIndex, this.selRowInd != tabIndex);
      console.log("TabChange", this.selRowInd, tabIndex, newTab, oldTab, this.rawDataList);
      if (this.selRowInd != tabIndex) {
        this.clearPagination();
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = tabIndex;
        this.rawDataType = this.rawDataList[tabIndex].id;
        this.selMutualTab = this.rawDataList[tabIndex].value;
        localStorage.setItem("mutualTab", this.rawDataType );
        localStorage.setItem("selMutualTab", this.selMutualTab);
        this.resetFilter();
        this.loadInitialData();
        this.getRawData();
      } else if (this.selRowInd == tabIndex) {
        this.selRowInd = tabIndex;
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getRawData();
    },
    clearPagination() {
      this.page = 1;
      this.current_page = 1;
      this.pageToLoad = 1;
      this.totalPages = 1;
      this.prevDisabled = 1;
      this.nextDisabled = 0;
      this.pages = [];
    },
    showSchemeHoldings(mfcode) {
      console.log('mfcode', mfcode);
      // this.$router.push({ name: 'Holdings', params: { id: mfcode } })
      // <router-link class="a-btn" :to="'/schemeholdings/:id/' tr[cl.title]">{{tr[cl.title]}}</router-link>
      this.$router.push({ path: `/schemeholdings/${mfcode}` });
    },
    showSchemeRatios(mfcode) {
      console.log('mfcode', mfcode);
      // this.$router.push({ name: 'Holdings', params: { id: mfcode } })
      // <router-link class="a-btn" :to="'/schemeholdings/:id/' tr[cl.title]">{{tr[cl.title]}}</router-link>
      this.$router.push({ path: `/schemeratios/${mfcode}` });
    },
    search() {
      if (this.searchText === null || this.searchText === "") {
          this.rawData = this.searchData;
          return this.rawData;
      } else if (this.searchText.length <= 2) {
          this.rawData = this.searchData;
          return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter(rd => {
          return (
              rd.nameamc.toLowerCase().includes(this.searchText.toLowerCase()) ||
              (rd.LNAME ?
                  rd.LNAME.toLowerCase().includes(this.searchText.toLowerCase()) :
                  false)
          );
        });
      }
    },
    filterSchemes() {
      if(this.rawDataType != 'scheme-returns' && this.rawDataType != 'fund-wise-monthly-aum') {     
        if(this.amc_name.length > 1 || this.scheme_name.length > 1 || this.lname.length > 1 || this.selFundManager != null || this.category.length > 1 || this.invType.length > 1){
          this.getRawData();
        } else {
          this.getRawData();
        }
      }
    },
    resetFilter() {
      this.fund_manager = this.scheme_name = this.lname = this.category = this.scheme_class = '';
      this.amc_name = '';
      this.selScheme = null;
      this.durDate = null; // new Date('2020-03-31'); //
      this.selSchemeClass = null;
      this.getRawData();
    },
    getScheme(){
      console.log('getScheme called', this.selScheme);
      if(this.selScheme) {
        this.scheme_name = this.selScheme.name;
        if(this.rawDataType != 'scheme-ratios' && this.rawDataType != 'scheme-asset-allocation' && this.rawDataType != 'avg-maturity-data'  && this.rawDataType != 'scheme-return-ranks') {
          this.filterSchemes();
        }
      } else {
        this.scheme_name = '';
        // console.log(this.selScheme);
        if(this.rawDataType != 'scheme-ratios' && this.rawDataType != 'scheme-asset-allocation'  && this.rawDataType != 'avg-maturity-data' && this.rawDataType != 'scheme-return-ranks') {
          this.filterSchemes();
        }
      }     
    },
    getFundManagerList() {
      let _this = this;
      http.get("mutual-funds/fund-manager", {}, function(error, response) {
        if(response.status == 'success'){
          var fundManagerList = response.data;
          var uniqueFundManagers = [];
          if (fundManagerList.length > 0) {
            fundManagerList.forEach((fundManager) => {
              if(_this.checkNotInArray(uniqueFundManagers, fundManager.fund_mgr)) {
                uniqueFundManagers.push(fundManager.fund_mgr);
                _this.fundManagerList.push({name: fundManager.fund_mgr, fund_manager: fundManager.fund_mgr});
              }
            });
            _this.fundManagerList = _this.sorted_fields_asc(
              _this.fundManagerList,
              "name"
            );
          }
        }
      });
    },
    getSchemesList() {
      let _this = this;
      http.get("mutual-funds/schemes?onlyCodeAndNames=1", {}, function(error, response) {
        if(response.status == 'success') {
          var schemeList = response.data;
          _this.schemeList = [];
          if (schemeList.length > 0) {
            schemeList.forEach((scheme) => {
              _this.schemeList.push({id: scheme.mf_schcode, name: scheme.sch_name});
            });
            _this.schemeList = _this.sorted_fields_asc(
              _this.schemeList,
              "id"
            );
          }
        }
      });
    },
    getSChemeClassCodes() {
      let _this = this;
      http.get("mutual-funds/scheme-class-codes", {}, function(error, response) {
        if(response.status == 'success') {
          var scheme_class_codes = response.data;
          _this.scheme_class_codes = [];
          if (scheme_class_codes.length > 0) {
              if(_this.rawDataType == 'scheme-return-ranks') {
                _this.selSchemeClass = {id: scheme_class_codes[0].classcode, name: scheme_class_codes[0].typename};
                _this.getRawData();
              }
            scheme_class_codes.forEach((scheme) => {
              _this.scheme_class_codes.push({id: scheme.classcode, name: scheme.typename});
             // if(scheme.classcode == 1) {
              //   _this.selSchemeClass = scheme;
              //   _this.scheme_class = scheme.id
              //   _this.schemeClassCode = scheme.id;
              // }
            });
          }
          console.log('_this.scheme_class_codes length', _this.scheme_class_codes.length);
        }
      });
    },
    loadInitialData() {
      if(this.rawDataType == 'schemes') {
        console.log('load schemes'); 
        this.getFundManagerList();
      }    
      if(this.rawDataType == 'whats-in-out' || this.rawDataType == 'schemes' || this.rawDataType == 'scheme-nav-latest' || 
          this.rawDataType == 'scheme-ratios' || this.rawDataType == 'avg-maturity-data' || this.rawDataType == 'scheme-asset-allocation' || this.rawDataType == 'scheme-returns' || this.rawDataType == 'scheme-master-info' || this.rawDataType == 'scheme-aum' || this.rawDataType == 'scheme-return-ranks') {
        console.log('load schemes');  
        this.getSchemesList();
      }
      if(this.rawDataType == 'whats-in-out' || this.rawDataType == 'scheme-nav-historical' || this.rawDataType == 'sector-historical' || this.rawDataType == 'scheme-return-ranks' || this.rawDataType == 'scheme-returns'  || this.rawDataType == 'category-wise-returns' || this.rawDataType == 'scheme-ratios' || this.rawDataType == 'avg-maturity-data' || this.rawDataType == 'scheme-asset-allocation') {
        this.getSChemeClassCodes();
      }
    },
    sortColumn(field, ind) {
      this.sort = field.title;
      var sortOrder = field.sort == 0 ? 2 : field.sort == 1 ? 2 : 1;      
      console.log(ind, sortOrder, typeof sortOrder, this.tableFields[ind], this.tableFields);
      if (sortOrder == 2) {
        this.sortOrder = 'DESC';
      } else  {
        this.sortOrder = 'ASC';
      }      
      this.tableFields[ind]['sort'] = sortOrder;
      console.log(this.sort, this.sortOrder);
      this.getRawData();
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      this.filterSchemes();
    },
    getSchemeClassCode () {
      console.log('getSchemeClassCode', this.selSchemeClass);
      if(this.selSchemeClass) {
        this.scheme_class = this.selSchemeClass.id
        this.schemeClassCode = this.selSchemeClass.id;
      } else {
        this.scheme_class = ''
        this.schemeClassCode = '';
      }
      if( this.rawDataType != 'scheme-returns' && this.rawDataType != 'avg-maturity-data' && this.rawDataType != 'scheme-ratios' && this.rawDataType != 'scheme-asset-allocation' && this.rawDataType != 'scheme-return-ranks') {
        this.getRawData();
      }
    },
    downLoadAll () {
      this.isDownload = 1;
      this.getRawData();
    }
  },
  data() {
    return {
      uncommonTabs: ['dashboard', 'whats-in-out', 'scheme-ratio-stats', 'scheme-asset-allocation', 'scheme-returns', 'scheme-nav-historical', 'sector-historical', 'scheme-return-ranks'],
      allDownloadTabs: ['fund-wise-monthly-aum', 'scheme-nav-latest', 'scheme-nav-historical', 'scheme-returns', 'scheme-ratios', 'sip-dates', 'avg-maturity-data', 'scheme-asset-allocation', 'scheme-aum', 'whats-in-out', 'scheme-return-ranks'], 
      schemeReturnRankRows: [],
      schemeReturnRanks: [],
      schemeReturnRankCols: [],
      typeMasterCategories: null,
      last_updated_date: null,
      durDate: null, //  new Date('2020-03-31'), //null,
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1))
      },
      dateFilterTabs: ['fund-wise-monthly-aum', 'scheme-nav-historical', 'scheme-aum', 'whats-in-out', 'scheme-asset-allocation', 'dividend-details',
       'scheme-ratios', 'scheme-returns', 'sector-historical', 'analysis', 'analysis-sum',
       'category-wise-returns', 'activities', 'avg-maturity-data', 'scheme-holdings', 'scheme-ratio-stats', 'whats-in-out', 'scheme-return-ranks', 'scheme-nav-latest'],
      selMutualTab: "",
      tableFields: [],
      tableColumns: [],
      catwiseTableFields: [],
      fundmngTableFields: [],
      searchText: "",
      schemeList: "",
      selScheme: null,
      fund_manager: '',
      selFundManager: null,
      fundManagerList: [],
      schemeList: [],
      scheme_name: '',
      scheme_class: '',
      schemeClassCode: '',
      selSchemeClass: null,
      isDownload: 0,
      scheme_class_codes: [],
      lname: '',
      amc_name: '',
      category: '',
      sector_search: '',
      invType: '',
      sortOrder: '',
      sort: '',
      actions: [],
      isApiCalled: 0,
      param: "fund-houses",
      currentComp: "",
      schemeReturnRanksDuration:[],
      rawDataList: [
        { id: "fund-houses", value: "Fund Houses", open: false, items: {}, isPaginate: 0 },
        // { id: "schemes", value: "Schemes", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-master-info", value: "Scheme Master Info", open: false, items: {}, isPaginate: 0 },
        { id: "fund-wise-monthly-aum", value: "Fund-wise Monthly AUM", open: false, items: {}, isPaginate: 0 },
        { id: "category-wise-returns", value: "Category-wise Returns", open: false, items: {}, isPaginate: 0 },
        { id: "category-amcwise", value: "Category Class Code", open: false, items: {}, isPaginate: 0 },
        { id: "amfi", value: "AMFI", open: false, items: {}, isPaginate: 0 },
        { id: "scheme-nav-latest", value: "Scheme NAV Latest", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-nav-historical", value: "Scheme NAV Historical", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-returns", value: "Scheme Returns", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-ratios", value: "Scheme Ratios", open: false, items: {}, isPaginate: 1 },
        { id: "dashboard", value: "Scheme dashboard", open: false, items: {}, isPaginate: 0 },
        { id: "type-master", value: "Type Master", open: false, items: {}, isPaginate: 0 },
        { id: "sector-historical", value: "Sector Historical", open: false, items: {}, isPaginate: 1 },
        { id: "dividend-details", value: "Dividend Details", open: false, items: {}, isPaginate: 1 },
        { id: "sip-dates", value: "SIP Dates", open: false, items: {}, isPaginate: 1 },
        { id: "activities", value: "Activities", open: false, items: {}, isPaginate: 1 },
        { id: "avg-maturity-data", value: "Avg Maturity Data", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-asset-allocation", value: "Scheme Asset Allocation", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-aum", value: "Scheme AUM", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-ratio-stats", value: "Scheme Ratio Stats", open: false, items: {}, isPaginate: 0 },
        { id: "whats-in-out", value: "Whats In-Out", open: false, items: {}, isPaginate: 1 },
        { id: "scheme-return-ranks", value: "Scheme Return Ranks", open: false, items: {}, isPaginate: 1 },
      ],
      rawDataType: "fund-houses",
      rawDataApi: "mutual-funds/",
      rawData: [],
      fillableData: [],
      statsFields: [
        {title: 'min', name: 'Min'},
        {title: 'max', name: 'Max'},
        {title: 'median', name: 'Median'},
        {title: 'mean', name: 'Mean'},
        {title: 'sum', name: 'Sum'},
        ],
      assetAllocFields: [
        {title: 'CurrentMonth', name: 'Current Month'},
        {title: 'Holding_CurrentMonth', name: 'Holding Current Month'},
        {title: 'Holding_PrevMonth', name: 'Holding Prev Month'},
        {title: 'mean', name: 'Mean'},
        {title: 'sum', name: 'Sum'},
        ],
      selRowInd: 0,
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      perPage: 200,
      schemeReturnTableFields: [
        {
          title: 'MF_SCHCODE',
          name: 'MF Scheme Code',
          datatype: 'string',
          sort_order: 1
        },
        {
          title: 'SCH_NAME',
          name: 'scheme Name',
          datatype: 'string',
          sort_order: 2
        },
        {
          title: 'SCHCLCODE',
          name: 'SClass Code',
          datatype: 'string',
          sort_order: 3
        },
        {
          title: 'DATE',
          name: 'Date',
          datatype: 'date',
          sort_order: 4
        },
        {
          title: 'LatNavDate',
          name: 'Latest Nav Date',
          datatype: 'date',
          sort_order: 5
        },
        {
          title: 'LatNavPrice',
          name: 'Latest Nav Price',
          datatype: 'numeric',
          sort_order: 6
        },
        {
          title: '1WEEK',
          name: '1W',
          datatype: 'numeric',
          sort_order: 7
        },
        {
          title: '1MONTH',
          name: '1M',
          datatype: 'numeric',
          sort_order: 8
        },
        {
          title: '1WEEK',
          name: '1W',
          datatype: 'numeric',
          sort_order: 9
        },
        {
          title: '3MONTH',
          name: '3M',
          datatype: 'numeric',
          sort_order: 10
        },
        {
          title: '6MONTH',
          name: '6M',
          datatype: 'numeric',
          sort_order: 11
        },
        {
          title: '1YEAR',
          name: '1 Yr',
          datatype: 'numeric',
          sort_order: 12
        },
        {
          title: '3YEAR',
          name: '3 Yr',
          datatype: 'numeric',
          sort_order: 13
        },
        {
          title: '5YEAR',
          name: '5 Yr',
          datatype: 'numeric',
          sort_order: 14
        },
        {
          title: 'inception',
          name: 'Since Inception',
          datatype: 'numeric',
          sort_order: 15
        },
        {
          title: 'WEEKMIN',
          name: 'Week Min',
          datatype: 'numeric',
          sort_order: 16
        },
        {
          title: 'wminname',
          name: 'Week Min Name',
          datatype: 'string',
          sort_order: 17
        },
        {
          title: '1MMIN',
          name: '1M Min',
          datatype: 'numeric',
          sort_order: 18
        },
        {
          title: '1mminname',
          name: '1M Min Name',
          datatype: 'string',
          sort_order: 19
        },
        {
          title: '3MMIN',
          name: '3M Min',
          datatype: 'numeric',
          sort_order: 19
        },
        {
          title: '3mminname',
          name: '3M Min Name',
          datatype: 'string',
          sort_order: 20
        },
        {
          title: '6MIN',
          name: '6M Min',
          datatype: 'numeric',
          sort_order: 21
        },
        {
          title: '6minname',
          name: '6M Min Name',
          datatype: 'string',
          sort_order: 22
        },
        {
          title: '1YRMIN',
          name: '1Yr Min',
          datatype: 'numeric',
          sort_order: 23
        },
        {
          title: '1yrminname',
          name: '1Yr Min Name',
          datatype: 'string',
          sort_order: 24
        },
        {
          title: '3YRMIN',
          name: '3Yrs Min',
          datatype: 'numeric',
          sort_order: 25
        },
        {
          title: '3yrminname',
          name: '3Yr Min Name',
          datatype: 'string',
          sort_order: 26
        },
        {
          title: '5YRMIN',
          name: '5Yrs Min',
          datatype: 'numeric',
          sort_order: 27
        },
        {
          title: '5yrminname',
          name: '5Yr Min Name',
          datatype: 'string',
          sort_order: 28
        },
        {
          title: 'INCMIN',
          name: 'Since Inception Min',
          datatype: 'numeric',
          sort_order: 29
        },
        {
          title: 'incminname',
          name: 'Since Inception Min Name',
          datatype: 'string',
          sort_order: 30
        },
        {
          title: 'WEEKMAX',
          name: 'Week Max',
          datatype: 'numeric',
          sort_order: 31
        },
        {
          title: 'wmaxname',
          name: 'Week Max Name',
          datatype: 'string',
          sort_order: 32
        },
        {
          title: '1MMAX',
          name: '1M Max',
          datatype: 'numeric',
          sort_order: 35
        },
        {
          title: '1mmaxname',
          name: '1M Max Name',
          datatype: 'string',
          sort_order: 36
        },
        {
          title: '3MMAX',
          name: '3M Max',
          datatype: 'numeric',
          sort_order: 37
        },
        {
          title: '3mmaxname',
          name: '3M Max Name',
          datatype: 'string',
          sort_order: 38
        },
        {
          title: '6MMAX',
          name: '6M Max',
          datatype: 'numeric',
          sort_order: 39
        },
        {
          title: '6mmaxname',
          name: '6M Max Name',
          datatype: 'string',
          sort_order: 40
        },
        {
          title: '1YRMAX',
          name: '1Y Max',
          datatype: 'numeric',
          sort_order: 41
        },
        {
          title: '1yrmaxname',
          name: '1Yr Max Name',
          datatype: 'string',
          sort_order: 42
        },
        {
          title: '3YRMAX',
          name: '3Yrs Max',
          datatype: 'numeric',
          sort_order: 43
        },
        {
          title: '3yrmaxname',
          name: '3Yrs Max Name',
          datatype: 'string',
          sort_order: 44
        },
        {
          title: '5YRMAX',
          name: '5Yrs Max',
          datatype: 'numeric',
          sort_order: 45
        },
        {
          title: '5yrmaxname',
          name: '5Yrs Max Name',
          datatype: 'string',
          sort_order: 46
        },
        {
          title: 'INCMAX',
          name: 'Since Inception Max',
          datatype: 'numeric',
          sort_order: 47
        },
        {
          title: 'incmaxname',
          name: 'Since Inception Max Name',
          datatype: 'string',
          sort_order: 48
        },
        {
          title: 'WEEKAVG',
          name: 'Week AVG',
          datatype: 'numeric',
          sort_order: 49
        },
        {
          title: '1MAVG',
          name: '1M AVG',
          datatype: 'numeric',
          sort_order: 50
        },
        {
          title: '3MAVG',
          name: '3M AVG',
          datatype: 'numeric',
          sort_order: 50
        },
        {
          title: '6MAVG',
          name: '6M AVG',
          datatype: 'numeric',
          sort_order: 51
        },
        {
          title: '1YRAVG',
          name: '1Yr AVG',
          datatype: 'numeric',
          sort_order: 52
        },
        {
          title: '3YRAVG',
          name: '3Yr AVG',
          datatype: 'numeric',
          sort_order: 53
        },
        {
          title: '5YRAVG',
          name: '5YR AVG',
          datatype: 'numeric',
          sort_order: 54
        },
        {
          title: 'INCAVG',
          name: 'Since Inception AVG',
          datatype: 'numeric',
          sort_order: 55
        },
        {
          title: 'Category_1WRet',
          name: 'Category 1W',
          datatype: 'numeric',
          sort_order: 56
        },
        {
          title: 'Category_1MRet',
          name: 'Category 1M',
          datatype: 'numeric',
          sort_order: 57
        },
        {
          title: 'Category_3MRet',
          name: 'Category 3M',
          datatype: 'numeric',
          sort_order: 58
        },
        {
          title: 'Category_6MRet',
          name: 'Category 6M',
          datatype: 'numeric',
          sort_order: 59
        },
        {
          title: 'Category_1YRet',
          name: 'Category 1Yr',
          datatype: 'numeric',
          sort_order: 60
        },
        {
          title: 'Category_3YRet',
          name: 'Category 3Yr',
          datatype: 'numeric',
          sort_order: 61
        },
        {
          title: 'Category_5YRet',
          name: 'Category 5Yr',
          datatype: 'numeric',
          sort_order: 62
        },
        {
          title: 'BM_1MRet',
          name: 'BM 1W',
          datatype: 'numeric',
          sort_order: 63
        },
        {
          title: 'BM_1MRet',
          name: 'BM 1M',
          datatype: 'numeric',
          sort_order: 64
        },
        {
          title: 'BM_3MRet',
          name: 'BM 3M',
          datatype: 'numeric',
          sort_order: 65
        },
        {
          title: 'BM_6MRet',
          name: 'BM 6M',
          datatype: 'numeric',
          sort_order: 66
        },
        {
          title: 'BM_1YRet',
          name: 'BM 1Yr',
          datatype: 'numeric',
          sort_order: 67
        },
        {
          title: 'BM_3YRet',
          name: 'BM 3Yr',
          datatype: 'numeric',
          sort_order: 68
        },
        {
          title: 'BM_5YRet',
          name: 'BM 5Yr',
          datatype: 'numeric',
          sort_order: 69
        },
      ]
    }
  },
  computed: {
    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  }
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
.table tr th span.sort.active{
  color: #ced4da;
}
.right-panel.fHeight {
  overflow: auto !important;
}
th.scheme-column {
  padding: 22px 70px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/rawdata.vue